import { render } from "./AddRegimePage.vue?vue&type=template&id=45a422d6&ts=true"
import script from "./AddRegimePage.vue?vue&type=script&lang=ts"
export * from "./AddRegimePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__